<section class="performance-page">
  <header class="page-heading">
    <div>
      <h2>Performance</h2>
    </div>
  </header>

  <div class="filters panel-card">
    <label class="field centrale-field">
      <span>Centrale</span>
      <select [ngModel]="installation()" (ngModelChange)="installation.set($event)">
        <option [ngValue]="null">Toutes les centrales</option>
        @for (centrale of centrales(); track centrale.id) { <option [ngValue]="centrale.id">{{ centrale.nom }}</option> }
      </select>
    </label>
    <label class="field">
      <span>Du</span>
      <input type="date" [ngModel]="dateDebut()" (ngModelChange)="dateDebut.set($event)">
    </label>
    <label class="field">
      <span>Au</span>
      <input type="date" [ngModel]="dateFin()" (ngModelChange)="dateFin.set($event)">
    </label>
    <label class="check-field">
      <input type="checkbox" [ngModel]="regrouper()" (ngModelChange)="regrouper.set($event); page.set(1)">
      <span>Regrouper par centrale</span>
    </label>
    <button class="apply-button" type="button" (click)="appliquerFiltres()">
      <span class="material-symbols-outlined">filter_alt</span>
      Appliquer
    </button>
  </div>

  <div class="metrics" aria-label="Synthèse de performance">
    <article class="metric panel-card">
      <span class="metric-icon production"><span class="material-symbols-outlined">bolt</span></span>
      <div><span>Production</span><strong>{{ synthese().productionMWh | number:'1.1-1':'fr' }} MWh</strong></div>
    </article>
    <article class="metric panel-card">
      <span class="metric-icon rendement"><span class="material-symbols-outlined">speed</span></span>
      <div><span>PR moyen</span><strong>{{ synthese().pr === null ? '—' : (synthese().pr | number:'1.1-1':'fr') + ' %' }}</strong></div>
    </article>
    <article class="metric panel-card">
      <span class="metric-icon gain"><span class="material-symbols-outlined">euro</span></span>
      <div><span>Gain estimé</span><strong>{{ synthese().gain | number:'1.1-1':'fr' }} k€</strong></div>
    </article>
    <article class="metric panel-card">
      <span class="metric-icon puissance"><span class="material-symbols-outlined">solar_power</span></span>
      <div><span>Puissance</span><strong>{{ synthese().puissance | number:'1.0-1':'fr' }} kWc</strong></div>
    </article>
  </div>

  <section class="table-card panel-card">
    @if (erreur()) {
      <div class="feedback error-feedback" role="alert">
        <span class="material-symbols-outlined">error</span><span>{{ erreur() }}</span>
        <button type="button" (click)="appliquerFiltres()">Réessayer</button>
      </div>
    }
    <div class="table-toolbar">
      <div class="result-count">
        <strong>Détail des performances</strong>
        <span>{{ lignesFiltrees().length }} résultat{{ lignesFiltrees().length > 1 ? 's' : '' }}</span>
      </div>
      <button mat-stroked-button class="export-button" type="button" [disabled]="exportEnCours()" (click)="exporterExcel()">
        @if (exportEnCours()) { <span class="button-spinner" aria-hidden="true"></span> }
        @else { <span class="material-symbols-outlined">download</span> }
        {{ exportEnCours() ? 'Export en cours…' : 'Exporter en Excel' }}
      </button>
      <label class="table-search">
        <span class="material-symbols-outlined">search</span>
        <input type="search" placeholder="Rechercher une centrale…" [ngModel]="recherche()" (ngModelChange)="recherche.set($event); appliquerFiltres()">
      </label>
    </div>

    <div class="table-scroll">
      <table>
        <thead><tr>
          <th><button type="button" (click)="changerTri('centrale')">Centrale <span class="material-symbols-outlined">{{ indicateurTri('centrale') }}</span></button></th>
          <th><button type="button" (click)="changerTri('batiment')">Bâtiment <span class="material-symbols-outlined">{{ indicateurTri('batiment') }}</span></button></th>
          <th class="number"><button type="button" (click)="changerTri('puissance')">Pc bât. <span class="material-symbols-outlined">{{ indicateurTri('puissance') }}</span></button></th>
          <th class="number"><button type="button" (click)="changerTri('irradiation')">Irradiation <span class="material-symbols-outlined">{{ indicateurTri('irradiation') }}</span></button></th>
          <th class="number"><button type="button" (click)="changerTri('production')">Production <span class="material-symbols-outlined">{{ indicateurTri('production') }}</span></button></th>
          <th class="number"><button type="button" (click)="changerTri('productionTheorique')">Prod. TH / Écart <span class="material-symbols-outlined">{{ indicateurTri('productionTheorique') }}</span></button></th>
          <th class="number"><button type="button" (click)="changerTri('productible')">Productible <span class="material-symbols-outlined">{{ indicateurTri('productible') }}</span></button></th>
          <th class="number"><button type="button" (click)="changerTri('pr')">PR <span class="material-symbols-outlined">{{ indicateurTri('pr') }}</span></button></th>
          <th class="number"><button type="button" (click)="changerTri('performance')">Perf. <span class="material-symbols-outlined">{{ indicateurTri('performance') }}</span></button></th>
          <th class="number"><button type="button" (click)="changerTri('perte')">Perte <span class="material-symbols-outlined">{{ indicateurTri('perte') }}</span></button></th>
          <th class="number"><button type="button" (click)="changerTri('disponibilite')">Tx. disponibilité <span class="material-symbols-outlined">{{ indicateurTri('disponibilite') }}</span></button></th>
          <!-- <th class="number"><button type="button" (click)="changerTri('gain')">Gain <span class="material-symbols-outlined">{{ indicateurTri('gain') }}</span></button></th> -->
          <!-- <th class="number"><button type="button" (click)="changerTri('rentabilite')">Rentabilité <span class="material-symbols-outlined">{{ indicateurTri('rentabilite') }}</span></button></th> -->
        </tr></thead>
        <tbody>
          @for (ligne of lignesPage(); track ligne.id) {
            <tr>
              <td class="site-name">{{ ligne.centrale }}</td><td>{{ ligne.batiment }}</td>
              <td class="number">@if (ligne.puissance !== null) { {{ ligne.puissance | number:'1.2-2':'fr' }} <span class="unit">kWc</span> } @else { <span class="empty">—</span> }</td>
              <td class="number">@if (ligne.irradiation !== null) { {{ ligne.irradiation | number:'1.3-3':'fr' }} <span class="unit">kWh/m²</span> } @else { <span class="empty">—</span> }</td>
              <td class="number">@if (ligne.production !== null) { {{ ligne.production | number:'1.2-2':'fr' }} <span class="unit">kWh</span> } @else { <span class="empty">—</span> }</td>
              <td class="number">@if (ligne.productionTheorique !== null) { {{ ligne.productionTheorique | number:'1.2-2':'fr' }} <span class="unit">kWh</span>
                                    @if (ligne.ecart !== null) { 
                                      @if(ligne.ecart! < 0) { <span style="color:red"> {{ ligne.ecart | number:'1.0-2':'fr' }} % </span> } @else { <span style="color:green"> {{ ligne.ecart | number:'1.0-2':'fr' }} % </span> }
                                    }
                                } @else { <span class="empty">—</span> }</td>
              <td class="number">@if (ligne.productible !== null) { {{ ligne.productible | number:'1.2-2':'fr' }} <span class="unit">kWh</span> } @else { <span class="empty">—</span> }</td>
              <td class="number">@if (ligne.pr !== null) { <span class="pr-chip" [class.good]="ligne.pr >= 80">{{ ligne.pr | number:'1.1-1':'fr' }} %</span> } @else { <span class="empty">—</span> }</td>
              <td class="number">@if (ligne.performance !== null) { {{ ligne.performance | number:'1.2-2':'fr' }} <span class="unit">h</span> } @else { <span class="empty">—</span> }</td>
              <td class="number">@if (ligne.perte !== null) { {{ ligne.perte | number:'1.2-2':'fr' }} <span class="unit">kWh</span> } @else { <span class="empty">—</span> }</td>
              <td class="number">@if (ligne.disponibilite !== null) { {{ ligne.disponibilite | number:'1.1-1':'fr' }} <span class="unit">%</span> } @else { <span class="empty">—</span> }</td>
              <!-- <td class="number gain-value">@if (ligne.gain !== null) { {{ ligne.gain | number:'1.3-3':'fr' }} <span class="unit">k€</span> } @else { <span class="empty">—</span> }</td> -->
              <!-- <td class="number">@if (ligne.rentabilite !== null) { {{ ligne.rentabilite | number:'1.1-1':'fr' }} <span class="unit">%</span> } @else { <span class="empty">—</span> }</td> -->
            </tr>
          } @empty {
            <tr><td class="empty-state" colspan="11">
              @if (chargement()) { <span class="loading-content"><span class="spinner"></span> Chargement des performances…</span> }
              @else if (!erreur()) { Aucun résultat ne correspond à la période et aux filtres sélectionnés. }
            </td></tr>
          }
        </tbody>
      </table>
    </div>

    <footer class="pagination">
      <label>Afficher <select [ngModel]="taillePage()" (ngModelChange)="changerTaille($event)"><option [value]="5">5</option><option [value]="10">10</option><option [value]="25">25</option></select></label>
      <span>{{ debutAffichage() }}–{{ finAffichage() }} sur {{ lignesFiltrees().length }}</span>
      <div class="page-buttons">
        <button type="button" aria-label="Page précédente" [disabled]="page() <= 1" (click)="pagePrecedente()"><span class="material-symbols-outlined">chevron_left</span></button>
        <strong>{{ page() }}</strong>
        <button type="button" aria-label="Page suivante" [disabled]="page() >= totalPages()" (click)="pageSuivante()"><span class="material-symbols-outlined">chevron_right</span></button>
      </div>
    </footer>
  </section>
</section>
